export const ENVIRONMENT_URL_POSTFIX = {
  development: '-dev',
  production: '',
  stage: '-stage',
  demo: '-developer'
};
